import React, { Component } from 'react';
import { Form, InputNumber, Modal, Row, Col, DatePicker } from 'antd';
import moment from 'moment';

const FormItem = Form.Item;

class Manage extends Component {
  handleOk = () => {
    const data = this.props.data || {};
    this.props.form.validateFields((err, values) => {
      const params = {};
      params.uuid = data.uuid;
      params.returnNumber = values.actualNumber;
      params.returnDate = values.actualDate.format('YYYY-MM-DD');
      if (!err) {
        this.props.handleOk(params);
      }
    });
  };

  render() {
    const {
      visible,
      handleCancel,
      form: { getFieldDecorator },
    } = this.props;
    const data = this.props.data || {};
    const formItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
    };
    return (
      <Modal
        title="资料借还"
        width="50%"
        visible={visible}
        onOk={this.handleOk}
        onCancel={() => handleCancel(false)}
      >
        <Form>
          <Row>
            <Col span={12}>
              <FormItem label="资料编号" {...formItemLayout}>
                <span>{data.no}</span>
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem label="资料借用时间" {...formItemLayout}>
                <span>{data.createTime ? moment(data.createTime).format('YYYY-MM-DD') : null}</span>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <FormItem label="资料归属" {...formItemLayout}>
                <span>{data.company}</span>
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem label="预计归还时间" {...formItemLayout}>
                <span>
                  {data.expectReturnDate
                    ? moment(data.expectReturnDate).format('YYYY-MM-DD')
                    : null}
                </span>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <FormItem label="借用数量" {...formItemLayout}>
                <span>{data.number}</span>
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem label="实际归还时间" {...formItemLayout}>
                {getFieldDecorator('actualDate', {
                  rules: [{ required: true, message: '请选择实际归还时间' }],
                })(<DatePicker />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <FormItem label="归还数量" {...formItemLayout}>
                {getFieldDecorator('actualNumber', {
                  rules: [{ required: true, message: '请填写要归还数量' }],
                })(<InputNumber min={1} max={data.number || 0} />)}
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(Manage);



// WEBPACK FOOTER //
// ./src/components/administrative/material/return/ModalReturn.js